import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';
import { PUBLIC_SENTRY_DSN } from '$env/static/public';

Sentry.init({
	dsn: PUBLIC_SENTRY_DSN,

	tracesSampleRate: 1.0, // In the future reduce this

	// Enable logs to be sent to Sentry
	enableLogs: true,

	replaysSessionSampleRate: 0.05,
	replaysOnErrorSampleRate: 0.5,

	// If you don't want to use Session Replay, just remove the line below:
	integrations: [replayIntegration()],
	beforeSend(event) {
		// Remove PII data
		if (event.user)  delete event.user.ip_address;
		if (event.request?.headers) delete event.request.headers['authorization'];
		return event;
	}
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
